import { actionTypes, mutationTypes } from '@/types';
import { uiComponents, uiStates } from '@/tools/viewState';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';

export default {
	state: {
		moves: 0,
		pieces: [],

		timeOut: false,
		puzzlePieces: [
			{ numberOfPieces: 4, level: 'einfach' },
			{ numberOfPieces: 5, level: 'mittel' },
			{ numberOfPieces: 6, level: 'schwer' },
		],
		gameLevel: 'easy',
		bubbleOneText: null,
		bubbleTwoText: null,
		cardMetaData: null,
	},
	actions: {
		[actionTypes.startPuzzleGame]({ commit, getters, rootState }) {
			let languageContent = null;
			commit(mutationTypes.viewStateSetUiState, [{ id: uiComponents.puzzle, uiState: uiStates.maximised }]);
			const { game } = getters.getArticleByType('puzzle');
			const uniqueMediaObjects = game.mediaObjectWithAttribution.reduce((acc, current) => {
				const mediaObject = acc.find((item) => item.source === current.source);
				if (!mediaObject) {
					return acc.concat([current]);
				} else {
					return acc;
				}
			}, []);
			const mediaData = uniqueMediaObjects.map((mediaObject) => {
				return {
					imageUrl: setUrlToDataSource(`../media-${mediaObject.source}/2048`, rootState.dataSourceURL),
					attribution: mediaObject.attribution,
				};
			});
			commit(mutationTypes.cardsMetaData, {
				metaData: mediaData,
			});
			if (rootState.gameMode === 'kids') {
				languageContent = getters.getArticleByType('puzzle');
			} else {
				languageContent = getters.getArticleByArticleTags('puzzlegameadultbubbleinfo');
			}
			// setting bubble data
			const [lc] = languageContent.languageContent.filter((lc) => lc.languageISO === getters.currentLanguage);
			const bubbleOneInfo = lc.title.split('|');
			const bubbleTwoInfo = lc.description.split('|');
			commit(mutationTypes.bubbleOneText, {
				bubbleOneText: bubbleOneInfo,
			});
			commit(mutationTypes.bubbleTwoText, {
				bubbleTwoText: bubbleTwoInfo,
			});
		},
		[actionTypes.setTimeOut]({ commit }, timeOut) {
			commit(mutationTypes.setTimeOut, timeOut);
		},
		[actionTypes.setGameLevel]({ commit }, gameLevel) {
			commit(mutationTypes.setGameLevel, gameLevel);
		},
		[actionTypes.restartPuzzleGame]({ commit }) {
			commit(mutationTypes.restartPuzzleGame);
		},
	},
	mutations: {
		[mutationTypes.setTimeOut](state, timeOut) {
			state.timeOut = timeOut;
		},
		[mutationTypes.setGameLevel](state, gameLevel) {
			state.gameLevel = gameLevel;
		},
		[mutationTypes.restartPuzzleGame](state) {
			state.moves = 0;
			state.pieces = [];
			state.timeOut = false;
			state.gameLevel = 'easy';
		},
		[mutationTypes.bubbleOneText](state, { bubbleOneText }) {
			state.bubbleOneText = bubbleOneText;
		},
		[mutationTypes.bubbleTwoText](state, { bubbleTwoText }) {
			state.bubbleTwoText = bubbleTwoText;
		},
		[mutationTypes.cardsMetaData](state, { metaData }) {
			state.cardsMetaData = metaData;
		},
	},
};
